<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.42756 15.8969L15.4489 8.89811C16.1837 8.53131 16.1837 7.4714 15.4489 7.1046L1.42756 0.105768C0.671024 -0.271862 -0.175425 0.420849 0.0317325 1.24808L1.53507 7.25129L6.15816 7.25129C6.56766 7.25129 6.89962 7.58708 6.89962 8.00129C6.89962 8.41551 6.56766 8.75129 6.15816 8.75129L1.5351 8.75129L0.0317319 14.7546C-0.175425 15.5819 0.671026 16.2746 1.42756 15.8969Z"
    fill="currentColor"
  />
</template>
